import client from './client'; // Ensure you import your configured Axios instance
import axios, {type AxiosProgressEvent} from 'axios';

export const uploadMedia = async (formData: FormData, onUploadProgress?: (progressEvent: AxiosProgressEvent) => void): Promise<any> => {
    try {
        const response = await client.post('/media/upload', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            },
            onUploadProgress // Pass the onUploadProgress callback here
        });
        return response.data; // Returns the response with file paths or success message
    } catch (error) {
        console.error('Error uploading media:', error);
        throw error; // Rethrowing the error allows handling it in the calling component
    }
};
